// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tenant-logo[data-v-5d9f606b]{width:140px}.tenant-logo img[data-v-5d9f606b]{height:100%;width:100%}.gradient-button[data-v-5d9f606b],.tenant-main-color[data-v-5d9f606b],div[data-v-5d9f606b]{color:var(--lms-tenant)}.nav-list p[data-v-5d9f606b]{color:var(--lms-tenant)!important}", ""]);
// Exports
module.exports = exports;
